const OcupacaoPredial = () => {
    return <h1>Ocupação Predial</h1>;
  };
  
  export default OcupacaoPredial;